import RateAgentOverview from "@/views/rating-report/RateAgentOverview";
import RateAgentDetails from "@/views/rating-report/RateAgentDetails";
import OverviewReportDashboard from "@/views/overview-report/OverviewReportDashboard";
import OverviewReportDetails from "@/views/overview-report/OverviewReportDetails";

export default [
    {
        path: '/',
        name: 'Main',
        view: 'Main',
        meta: { requiresAuth: true }
    },
    {
        path: '/bot/:bot_code/s/:senderId',
        name: 'Channel',
        view: 'Main',
        meta: { requiresAuth: true }
    },
    {
        path: '/bot/:bot_code/',
        name: 'Bot',
        view: 'Main',
        meta: { requiresAuth: true }
    },
    {
        path: '/statistic',
        name: 'Statistic',
        view: 'statistic/Statistic',
        meta: { requiresAuth: true }
    },
    {
        path: '/statistic/:botCode',
        name: 'Statistic/Bot',
        view: 'statistic/Statistic',
        meta: { requiresAuth: true }
    },
    {
        path: '/session-info',
        name: 'SessionInfo',
        view: 'session-info/SessionInfo',
        meta: { requiresAuth: true }
    },
    {
        path: '/session-info/:botCode',
        name: 'SessionInfoWithBotCode',
        view: 'session-info/SessionInfo',
        meta: { requiresAuth: true }
    },
    {
        path: '/sender/:botCode',
        name: 'SenderWithBotCode',
        view: 'sender/Sender',
        meta: { requiresAuth: true }
    },
    {
        path: '/ticket-management/:botCode',
        name: 'TicketManagement',
        view: 'ticket-management/TicketManagement',
        meta: { requiresAuth: true }
    },
    {
        path: '/bot/:botCode/conversation-types-report',
        name: 'ConversationTypesReport',
        view: 'conversation-report/ConversationTypesReport',
        meta: { requiresAuth: true }
    },
    {
        path: '/overview-report/:bot_code',
        name: 'OverviewReport',
        view: 'overview-report/Index',
        redirect: '/overview-report/:bot_code/dashboard',
        meta: { requiresAuth: true },
        children: [
            {
                path: 'dashboard',
                name: 'OverviewReportDashboard',
                component: OverviewReportDashboard
            },
            {
                path: 'details',
                name: 'OverviewReportDetails',
                component: OverviewReportDetails
            },
        ]
    },
    {
        path: '/report-categories/:botCode',
        name: 'ReportCategories/Bot',
        view: 'report-categories/ReportCategories',
        meta: { requiresAuth: true }
    },
    {
        path: '/report-categories',
        name: 'ReportCategories',
        view: 'report-categories/ReportCategories',
        meta: { requiresAuth: true }
    },
    {
        path: '/settings/:botCode',
        name: 'Settings',
        view: 'settings/Settings',
        meta: { requiresAuth: true }
    },
    {
        path: '/notifications',
        name: 'Notification',
        view: 'notification/Notification',
        meta: { requiresAuth: true }
    },
    {
        path: '/authentication/:provider/complete',
        name: 'AuthComplete',
        view: 'auth/AuthComplete',
        meta: {requiresAuth: false}
    },
    {
        path: '/chat-history/:bot_code/s/:sender_id/ss/:session_id',
        name: 'ChatHistoryBySession',
        view: 'chat-history/HistoryBySession',
        meta: {requiresAuth: true}
    },
    {
        path: '/dashboard-realtime/:bot_code',
        name: 'DashBoardRealtime',
        view: 'dashboard-realtime/Index',
        meta: {requiresAuth: true}
    },
    {
        path: '/dashboard/:bot_code',
        name: 'DashBoard',
        view: 'dashboard/Index',
        meta: {requiresAuth: true}
    },
    {
        path: '/agent-monitor/:botCode',
        name: 'AgentMonitor',
        view: 'agent-monitor/Index',
        meta: { requiresAuth: true }
    },
    {
        path: '/rating-report/:bot_code',
        name: 'RatingReport',
        view: 'rating-report/Index',
        redirect: '/rating-report/:bot_code/rate-agent/overview',
        meta: {requiresAuth: true},
        children: [
            {
                path: 'rate-agent/overview',
                name: 'RateAgentDetails',
                component: RateAgentOverview
            },
            {
                path: 'rate-agent/details',
                name: 'RateAgentDetails',
                component: RateAgentDetails
            },
        ]
    },
    {
        path: '/sla-report/:botCode',
        name: 'SLAReport',
        view: 'sla/SLAReport',
        meta: { requiresAuth: true }
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        view: 'error/AccessDenied'
    },
]
